import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupTextPipe } from './suptext.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [SupTextPipe],
  exports: [SupTextPipe]
})
export class SupTextModule {}
